import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export const useConditions = function (frameId: string) {
    return useQuery(`${frameId}-conditions`, () => new Client().compressor_GetCompressorConditions(frameId), {
        refetchOnWindowFocus: false,
        staleTime: 180000
    })
};